(function () {
  function init() {
    var root = document.getElementById('shopify-header-section');
    if (!root) return;
    var sticky = root.querySelector('sticky-header');
    var target = sticky || root.querySelector('header.header') || root.querySelector('header') || root;
    function onScroll() {
      if (window.scrollY > 40) target.classList.add('viva-header--scrolled');
      else target.classList.remove('viva-header--scrolled');
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
